import type { ReactNode } from 'react'
import { Logo } from '../Logo/Logo'
import './PromoBand.css'

export type PromoBandTone = 'orange' | 'dark'
export type PromoBandWatermark = 'logo' | 'wordmark'

export interface PromoBandProps {
  tone: PromoBandTone
  children: ReactNode
  cta?: ReactNode
  watermark?: PromoBandWatermark
  attribution?: ReactNode
  quote?: boolean
}

export function PromoBand({ tone, children, cta, watermark, attribution, quote = false }: PromoBandProps) {
  const classes = ['azoya-promo-band', `azoya-promo-band--${tone}`, quote ? 'azoya-promo-band--quote' : '']
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classes}>
      {watermark === 'logo' && (
        <span className="azoya-promo-band-watermark">
          <Logo size={260} opacity={0.15} />
        </span>
      )}
      {watermark === 'wordmark' && (
        <span className="azoya-promo-band-wordmark" aria-hidden="true">
          AZOYA
        </span>
      )}
      <p className="azoya-promo-band-text">{children}</p>
      {attribution && <p className="azoya-promo-band-attribution">{attribution}</p>}
      {cta}
    </div>
  )
}
